import React from 'react'
import {useTranslation} from 'react-i18next'
import down from 'pages/HealthCenter/Report/HealthCenterMajorIndicators/down.svg'
import {SCORE_HEALTH, SCORE_SUMMARY} from 'constants/HealthCenterConstant'
import useHealthCenterStyles from 'pages/HealthCenter/Report/HealthCenterMajorIndicators/Style'
import useLanguage from 'features/languageReport/useLanguage'

interface Props {
  headerName: string
  backgroundColor: string
  textRound: {
    value: number
    frequency?: string
    status: string
  }
  percentage: number
  index: number
  top: string
  middle: string
  bottom: string
  showHz?: boolean
  isHealth?: boolean
  isEEG?: boolean
}

function PercentChangeBarCard({
  headerName,
  backgroundColor,
  textRound,
  percentage,
  index,
  top,
  middle,
  bottom,
  showHz = true,
  isHealth = false,
  isEEG = false,
}: Props) {
  const {t, i18n} = useTranslation()
  const classes = useHealthCenterStyles()
  const {percentile, scoreUnit} = useLanguage(isEEG ? 'eeg' : 'health')

  const getNumber = (value: string | number) => {
    if (!Number.isNaN(Number(value))) return value
    return 0
  }
  return (
    <div className={classes.percentBar}>
      <div style={{paddingBottom: 25}}>
        <div className={classes.percentBarHeaderName}>
          <p>{headerName}</p>
        </div>
        <div
          className={classes.arrowIconShort}
          // Offset of the arrow icon's size
          style={{marginLeft: `${percentage - 1}%`}}
        />

        <div className={classes.colorBarNormal}>
          {index === 4 && (
            <>
              <div
                className={
                  !percentage || percentage <= SCORE_HEALTH.high
                    ? classes.marker2
                    : classes.marker1
                }
                style={{
                  left: `${isHealth ? SCORE_HEALTH.low : SCORE_SUMMARY.low}%`,
                }}
              />
              <div
                className={
                  !percentage || percentage <= SCORE_HEALTH.high
                    ? classes.marker2
                    : classes.marker1
                }
                style={{
                  left: `${isHealth ? SCORE_HEALTH.high : SCORE_SUMMARY.high}%`,
                }}
              />
            </>
          )}
          {(index === 1 || index === 2 || index === 3 || index === 5) && (
            <>
              <div
                className={classes.marker1}
                style={{
                  left: `${isHealth ? SCORE_HEALTH.low : SCORE_SUMMARY.low}%`,
                }}
              />
              <div
                className={classes.marker1}
                style={{
                  left: `${isHealth ? SCORE_HEALTH.high : SCORE_SUMMARY.high}%`,
                }}
              />
            </>
          )}

          <div
            className={classes.colorBarFillNormal}
            style={{
              width: `${Number(percentage) ?? 0}%`,
              backgroundColor: `${backgroundColor}`,
            }}
          />
        </div>
        <div className={classes.contentBarPerNotificationV2}>
          <div className={classes.contentBarPerNotificationV2Child}>
            <div style={{position: 'absolute', left: `${percentile.low - 4}%`}}>
              {top}
            </div>
            <div style={{position: 'absolute', left: `${50 - 4}%`}}>
              {middle}
            </div>
            <div
              style={{position: 'absolute', left: `${percentile.high - 4}%`}}
            >
              {bottom}
            </div>
          </div>
        </div>
      </div>
      <div
        className={classes.round}
        style={{
          backgroundColor: `${backgroundColor}`,
        }}
      >
        <div className={classes.textRound}>
          <p>
            {getNumber(textRound.value)}
            {i18n.language !== 'en' && scoreUnit}
          </p>
          {textRound.frequency && textRound.frequency !== '0' && showHz && (
            <p className={`${classes.frequencyText} ${classes.textRoundItem2}`}>
              {textRound.frequency}
            </p>
          )}
          <p className={classes.textRoundItem3}>{textRound.status}</p>
        </div>
      </div>
    </div>
  )
}

export default PercentChangeBarCard
